import OnboardingNavBar from "@qoohoo/common/components/NavBar/OnboardingNavBar";
import OnboardingForm from "components/onboarding/OnboardingForm";

export default function Onboarding() {
  return (
    <div className="h-screen relative w-full flex flex-col bg-white text-[#16191B]">
      <OnboardingNavBar
        sticky={true}
        isLightMode={true}
        bodyBackgroundColor={"white"}
        showBorder
      />
      <OnboardingForm initialFormData={{}} />
    </div>
  );
}
